/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-08-28 18:15:15
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-01-26 15:56:23
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/enquiryManage/components/multipleSelection/multipleSelection.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  data() {
    return {
      multipleSelection: [],
      multipleSelectionAll: [],
    };
  },
  methods: {
    // 取消跨页面多选
    clearTable() {
      this.multipleSelection = []; // 清空当前列表页选择的数据项
      this.multipleSelectionAll = []; // 清空已选择的数据项
      this.$refs.tableData.clearSelection(); // 清除全部的选中状态
    },
    // -- 跨页多选方法 --
    // 设置选中的方法
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      const { idKey } = this;
      const selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.tableData.clearSelection();
      this.$nextTick(() => {
        for (let i = 0; i < this.tableData.length; i++) {
          if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
            this.$refs.tableData.toggleRowSelection(this.tableData[i], true);
          }
        }
      });
    },
    // 记忆选择核心方法
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      const { idKey } = this;
      const that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      const selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      const selectIds = [];

      // 获取当前页选中的id
      this.multipleSelection.forEach((row) => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      const noSelectIds = [];
      // 得到当前页没有选中的id
      this.tableData.forEach((row) => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach((id) => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    // 得到选中的所有数据
    getAllSelectionData() {
      this.changePageCoreRecordData();
    },
  },
};
